module.exports = __webpack_public_path__ + "static/img/Lachie_Neale_mobile.4e35549.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Lachie_Neale_mobile.jpg
// module id = 15Y0
// module chunks = 0